/* eslint-disable @typescript-eslint/naming-convention */
import type { Locale } from '@change-corgi/config/locales';

export const OG_IMAGE = 'https://static.change.org/brand-pages/impact/opengraph-impact.jpg';

export const BG_HERO_IMAGE = 'https://static.change.org/brand-pages/hero%20images/hero-impact.jpg';

export const BG_IMPACT_GRID_IMAGE = 'https://static.change.org/brand-pages/impact/Impact-grid-720.jpg';

export const TAKE_ACTION_IMG_URLS = [
	{ url: 'https://assets.change.org/photos/0/yy/zc/gWYYzCYDQyKGmrE-400x400-noPad.jpg?1515620392', desktopOnly: false },
	{ url: 'https://assets.change.org/photos/6/th/va/vlthvAdgSBLJPbs-400x400-noPad.jpg?1516866413', desktopOnly: false },
	{ url: 'https://assets.change.org/photos/8/oj/zm/bdojZMUCvzxRSSN-400x400-noPad.jpg?1515937258', desktopOnly: false },
	{ url: 'https://assets.change.org/photos/5/rm/sw/fqRMSWIetwCbMdr-400x400-noPad.jpg?1529531543', desktopOnly: false },
	{ url: 'https://assets.change.org/photos/0/dd/jy/moddjygCUsqZeUU-400x400-noPad.jpg?1527833572', desktopOnly: false },
	{ url: 'https://assets.change.org/photos/9/vc/mo/mZVcmOgOGUpHrOK-400x400-noPad.jpg?1549338689', desktopOnly: true },
	{ url: 'https://assets.change.org/photos/1/to/vq/xQtovqHuVIqhqRI-400x400-noPad.jpg?1518110273', desktopOnly: true },
	{ url: 'https://assets.change.org/photos/4/uh/hh/SyuHHHqdVsyVKmH-400x400-noPad.jpg?1526415237', desktopOnly: true },
	{ url: 'https://assets.change.org/photos/7/nm/uu/annMUUrTrNFbZop-400x400-noPad.jpg?1525655156', desktopOnly: true },
	{ url: 'https://assets.change.org/photos/3/ty/qd/kVTyqDrStkbfcet-400x400-noPad.jpg?1492701055', desktopOnly: true },
	{ url: 'https://assets.change.org/photos/3/xm/iw/mJXMiwwezzDlWpy-400x400-noPad.jpg?1491589145', desktopOnly: true },
	{ url: 'https://assets.change.org/photos/4/sa/ro/TxsaROVUlPAGtWc-400x400-noPad.jpg?1517907141', desktopOnly: true },
	{ url: 'https://assets.change.org/photos/5/jc/dp/UFJcdpSiDUzVeMG-400x400-noPad.jpg?1537204801', desktopOnly: true },
];

export const LOCALE_REPORT_MAP: Partial<Record<Locale, string>> = {
	'en-US': 'https://static.change.org/brand-pages/impact/reports/2020/2020_Impact+Report_Change_EN_final.pdf',
	'es-AR': 'https://static.change.org/brand-pages/impact/reports/2019/change.org_Impact_Report_argentina_FINAL.pdf',
	'es-ES': 'https://static.change.org/brand-pages/impact/reports/2020/2020_Impact+Report_Change_ES_v02.pdf',
	'es-419': 'https://static.change.org/brand-pages/impact/reports/2021/2021_impact_report_latam.pdf',
	'fr-FR': 'https://static.change.org/brand-pages/impact/reports/2020/2020_Impact+Report_Change_FR_v02.pdf',
	'it-IT': 'https://static.change.org/brand-pages/impact/reports/2020/2020_Impact+Report_Change_IT_180920.pdf',
	'ja-JP': 'https://static.change.org/brand-pages/impact/reports/2023/Japan-ImpactReport2023.pdf',
	'ru-RU': 'https://static.change.org/brand-pages/impact/reports/2019/change.org_Impact_Report_russian_FINAL.pdf',
	'tr-TR': 'https://static.change.org/brand-pages/impact/reports/2021/2021_Impact%2BReport_Change_TR.pdf',
};

export const MEMBERSHIP_COUNTRY_CONFIG: Record<string, { color: string; imageUrl?: string }> = {
	default: {
		color: '#e6d7d6',
		imageUrl: 'https://static.change.org/brand-pages/subscriptions/us/protesters.png',
	},
	AU: {
		color: '#e9e3db',
		imageUrl: 'https://static.change.org/brand-pages/subscriptions/au/protesters.png',
	},
	GB: {
		color: '#e5dcdf',
		imageUrl: 'https://static.change.org/brand-pages/subscriptions/gb/protesters.png',
	},
	ES: {
		color: '#d8d6e5',
		imageUrl: 'https://static.change.org/brand-pages/subscriptions/es/protesters.png',
	},
	FR: {
		color: '#e6d7d6',
		imageUrl: 'https://static.change.org/brand-pages/subscriptions/fr/protesters.png',
	},
	IT: {
		color: '#e6d7d6',
		imageUrl: 'https://static.change.org/brand-pages/subscriptions/it/protesters.png',
	},
	RU: {
		color: '#e6d7d6',
	},
	AR: {
		color: '#dbd9db',
		imageUrl: 'https://static.change.org/brand-pages/subscriptions/ar/protesters.png',
	},
	CO: {
		color: '#e6d7d6',
		imageUrl: 'https://static.change.org/brand-pages/subscriptions/co/protesters.png',
	},
	JP: {
		color: '#f0e6de',
		imageUrl: 'https://static.change.org/brand-pages/subscriptions/jp/protesters.png',
	},
};

export const VIDEO_EMBED_IDS: Partial<Record<Locale, string>> & { default: string } = {
	'es-ES': 'U1LFGelN2aY',
	'es-419': 'U1LFGelN2aY',
	'es-AR': 'U1LFGelN2aY',
	'fr-FR': 'SZgKJXoscRU',
	default: 'UcT1rgZDko4',
};

export const ccLocaleMap: Partial<Record<Locale, string>> = {
	'en-US': 'en',
	'en-IN': 'en',
	'en-GB': 'en',
	'en-CA': 'en',
	'en-AU': 'en',
	'es-ES': 'es',
	'es-AR': 'es-mx',
	'fr-FR': 'fr',
	'de-DE': 'de',
	'id-ID': 'id',
	'ko-KR': 'ko',
	'ja-JP': 'ja',
	'it-IT': 'it',
	'ru-RU': 'ru',
	'es-419': 'es-mx',
	'th-TH': 'th',
	'tl-PH': 'tl',
	'tr-TR': 'tr',
	'pt-BR': 'pt-br',
};
